"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultsDTO = void 0;
const isFunction_js_1 = require("../../../../utils/validation/isFunction.js");
const getDefaultsDTO = (attr) => {
    const defaultsDTO = {};
    for (const mode of ['put', 'key', 'update']) {
        const modeDefault = attr.defaults[mode];
        if (modeDefault === undefined) {
            continue;
        }
        defaultsDTO[mode] = (0, isFunction_js_1.isFunction)(modeDefault)
            ? { defaulterId: 'custom' }
            : { defaulterId: 'value', value: modeDefault };
    }
    return defaultsDTO;
};
exports.getDefaultsDTO = getDefaultsDTO;
